import * as yup from 'yup';


export const validationSchema = yup.object({
  title: yup
    .string()
    .required('Field is required'),
  discountType: yup.object().shape({
    name: yup
      .string()
      .required('Field is required')
  }),
  percentageOff: yup.object().shape({
    discount: yup
      .string()
      .when('isActive', {
        is: true,
        then: yup
          .string()
          .test('discount', 'Invalid percent', (val) => {
            if (!val) {
              return true;
            }

            return val.match(/^[1-9]%$|^[1-9][0-9]%$|^(100)%$/);
          })
          .required('Field is required')
      }),
    appliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      }),
    notAppliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      })
  }),
  dollarOff: yup.object().shape({
    discount: yup
      .string()
      .when('isActive', {
        is: true,
        then: yup
          .string()
          .required('Field is required')
      }),
    discountTo: yup
      .string()
      .when('isActive', {
        is: true,
        then: yup
          .string()
          .required('Field is required')
      }),
    appliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      }),
    notAppliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      })
  }),
  fixedPrice: yup.object().shape({
    price: yup
      .string()
      .when('isActive', {
        is: true,
        then: yup
          .string()
          .required('Field is required')
      }),
    appliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      }),
    notAppliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      })
  }),
  buyXGetY: yup.object({
    isActive: yup.boolean(),
    customerBuys: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          minBuy: yup.object({
            name: yup
              .string()
              .required('Field is required'),
            value: yup
              .string()
              .when('name', {
                is: 'Minimum quantity of items',
                then: yup
                  .string()
                  .required('Field is required')
              })
              .when('name', {
                is: 'Minimum purchase amount',
                then: yup
                  .string()
                  .required('Field is required')
              })
          }),
          appliesTo: yup.object().shape({
            name: yup
              .string()
              .required('Field is required'),
            isCategories: yup.bool().when(['name', 'isListings'], {
              is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
              then: yup.bool().oneOf([true], 'At least one needs to be selected')
            }),
            isListings: yup.bool().when(['name', 'isCategories'], {
              is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
              then: yup.bool().oneOf([true], 'At least one needs to be selected')
            }),
            value: yup.object()
              .when('isCategories', {
                is: true,
                then: yup.object({
                  categories: yup
                    .array()
                    .min(1, 'Field is required')
                    .required('Field is required')
                })
              })
              .when('isListings', {
                is: true,
                then: yup.object({
                  listings: yup
                    .array()
                    .min(1, 'Field is required')
                    .required('Field is required')
                })
              })
          }, ['isCategories', 'isListings'])
        })
      }),
    customerGet: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          quantity: yup
            .string()
            .required('Field is required'),
          appliesTo: yup.object().shape({
            isCategories: yup.bool().when('isListings', {
              is: (isListings) => !isListings,
              then: yup.bool().oneOf([true], 'At least one needs to be selected')
            }),
            isListings: yup.bool().when('isCategories', {
              is: (isCategories) => !isCategories,
              then: yup.bool().oneOf([true], 'At least one needs to be selected')
            }),
            value: yup.object()
              .when('isCategories', {
                is: true,
                then: yup.object({
                  categories: yup
                    .array()
                    .min(1, 'Field is required')
                    .required('Field is required')
                })
              })
              .when('isListings', {
                is: true,
                then: yup.object({
                  listings: yup
                    .array()
                    .min(1, 'Field is required')
                    .required('Field is required')
                })
              })
          }, ['isCategories', 'isListings'])
        })
      }),
    discountValue: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          name: yup
            .string()
            .required('Field is required'),
          value: yup
            .string()
            .when('name', {
              is: 'Percentage OFF',
              then: yup
                .string()
                .test('value', 'Invalid percent', (val) => {
                  if (!val) {
                    return true;
                  }

                  return val.match(/^[1-9]%$|^[1-9][0-9]%$|^(100)%$/);
                })
                .required('Field is required')
            })
            .required('Field is required')
        })
      })
  }),
  everyNth: yup.object({
    discountOn: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          name: yup
            .string()
            .required('Field is required'),
          value: yup
            .string()
            .when('name', {
              is: 'Every quantity of item',
              then: yup.string().required('Field is required')
            })
            .when('name', {
              is: 'Every purchase amount',
              then: yup.string().required('Field is required')
            })
        })
      }),
    discountValue: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          name: yup
            .string()
            .required('Field is required'),
          value: yup
            .string()
            .when('name', {
              is: 'Percentage OFF',
              then: yup
                .string()
                .test('value', 'Invalid percent', (val) => {
                  if (!val) {
                    return true;
                  }

                  return val.match(/^[1-9]%$|^[1-9][0-9]%$|^(100)%$/);
                })
                .required('Field is required')
            })
            .required('Field is required')
        })
      }),
    appliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      }),
    notAppliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object().shape({
          name: yup
            .string()
            .required('Field is required'),
          isCategories: yup.bool().when(['name', 'isListings'], {
            is: (name, isListings) => name === 'Specific Categories/Listings' && !isListings,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          isListings: yup.bool().when(['name', 'isCategories'], {
            is: (name, isCategories) => name === 'Specific Categories/Listings' && !isCategories,
            then: yup.bool().oneOf([true], 'At least one needs to be selected')
          }),
          value: yup.object()
            .when('isCategories', {
              is: true,
              then: yup.object({
                categories: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
            .when('isListings', {
              is: true,
              then: yup.object({
                listings: yup
                  .array()
                  .min(1, 'Field is required')
                  .required('Field is required')
              })
            })
        }, ['isCategories', 'isListings'])
      })
  }),
  bundle: yup.object({
    appliesTo: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          value: yup
            .array()
            .min(1, 'Field is required')
            .required('Field is required')
        })
      }),
    discountValue: yup.object()
      .when('isActive', {
        is: true,
        then: yup.object({
          name: yup
            .string()
            .required('Field is required'),
          value: yup
            .string()
            .when('name', {
              is: 'Percentage OFF',
              then: yup
                .string()
                .test('value', 'Invalid percent', (val) => {
                  if (!val) {
                    return true;
                  }

                  return val.match(/^[1-9]%$|^[1-9][0-9]%$|^(100)%$/);
                })
                .required('Field is required')
            })
            .required('Field is required')
        })
      })
  }),
  minOrderAmount: yup
    .mixed()
    .when('percentageOff.isActive', {
      is: true,
      then: yup.object({
        name: yup
          .string()
          .required('Field is required'),
        value: yup
          .string()
          .when('name', {
            is: 'Purchase Amount',
            then: yup
              .string()
              .required('Field is required')
          })
          .when('name', {
            is: 'Quantity',
            then: yup
              .string()
              .required('Field is required')
          })
      })
    })
    .when('dollarOff.isActive', {
      is: true,
      then: yup.object({
        name: yup
          .string()
          .required('Field is required'),
        value: yup
          .string()
          .when('name', {
            is: 'Purchase Amount',
            then: yup
              .string()
              .required('Field is required')
          })
          .when('name', {
            is: 'Quantity',
            then: yup
              .string()
              .required('Field is required')
          })
      })
    })
    .when('fixedPrice.isActive', {
      is: true,
      then: yup.object({
        name: yup
          .string()
          .required('Field is required'),
        value: yup
          .string()
          .when('name', {
            is: 'Purchase Amount',
            then: yup
              .string()
              .required('Field is required')
          })
          .when('name', {
            is: 'Quantity',
            then: yup
              .string()
              .required('Field is required')
          })
      })
    })
    .when('bundle.isActive', {
      is: true,
      then: yup.object({
        name: yup
          .string()
          .required('Field is required'),
        value: yup
          .string()
          .when('name', {
            is: 'Purchase Amount',
            then: yup
              .string()
              .required('Field is required')
          })
          .when('name', {
            is: 'Quantity',
            then: yup
              .string()
              .required('Field is required')
          })
      })
    })
    .when('freeShipping.isActive', {
      is: true,
      then: yup.object({
        name: yup
          .string()
          .required('Field is required'),
        value: yup
          .string()
          .when('name', {
            is: 'Purchase Amount',
            then: yup
              .string()
              .required('Field is required')
          })
          .when('name', {
            is: 'Quantity',
            then: yup
              .string()
              .required('Field is required')
          })
      })
    }),
  customerGroups: yup.object({
    name: yup
      .string()
      .required('Field is required'),
    value: yup
      .array()
      .when('name', {
        is: 'Specific group of customers',
        then: yup
          .array()
          .min(1, 'Field is required')
          .required('Field is required')
      }),
    specificGroupSelectionCheckbox: yup
      .boolean()
      .test({
        name: 'specificGroupSelectionCheckbox',
        message: 'Field is required',
        test(value) {
          const { name } = this.parent;
          return name === 'Specific group of customers' ? value : true;
        },
      }),
  }),
  usageLimits: yup.object({
    shoppingQuantity: yup.object({
      value: yup
        .string()
        .when('checked', {
          is: true,
          then: yup
            .string()
            .required('Field is required')
        })
    }),
    perCustomer: yup.object({
      value: yup
        .string()
        .when('checked', {
          is: true,
          then: yup
            .string()
            .required('Field is required')
        })
    }),
    usageLimitsSelectionCheckbox: yup.boolean().test({
      name: 'usageLimitsSelectionCheckboxRequired',
      message: 'Field is required',
      test(value) {
        const { perCustomer } = this.parent;
        return perCustomer.checked ? value : true;
      },
    }),
  }),
  dates: yup.object({
    startDate: yup
      .string()
      .nullable()
      .required('Field is required'),
    startTime: yup
      .string()
      .nullable()
      .required('Field is required'),
    endDate: yup
      .string()
      .nullable()
      .when('isEndDates', {
        is: true,
        then: yup
          .string()
          .nullable()
          .required('Field is required')
      }),
    endTime: yup
      .string()
      .nullable()
      .when('isEndDates', {
        is: true,
        then: yup
          .string()
          .nullable()
          .required('Field is required')
      })
  })
});
